import { ArriveTimeState } from "store/slices/arriveTime";
import { timeValues } from "pages/OrderModal/components/TimeSection/constants";
import { format } from "date-fns";
import { uk } from "date-fns/locale";

export const defineTime = (time: ArriveTimeState) => {
  if (time.value === timeValues.now) {
    return time.title.toLowerCase();
  } else {
    const date = new Date(time.dateTime);

    return format(date, "HH:mm, dd MMMM, EEEE", { locale: uk });
  }
};

export const formatOptions = (options: string[]) => {
  if (options.length <= 2) {
    return options.join(", ").toLowerCase();
  }
  return `${options.slice(0, 2).join(", ").toLowerCase()}...`;
};
